const MIN_QUATERNION_LENGTH = 1e-8;

/**
 * Normalizes a quaternion and writes it to a flat Float32Array
 * using the renderer's WXYZ storage convention.
 *
 * Invalid or near-zero quaternions fall back to the identity rotation.
 */
export function writeNormalizedQuaternionWXYZ(
  destination,
  outputIndex,
  w,
  x,
  y,
  z,
) {
  const offset = outputIndex * 4;
  const length = Math.hypot(w, x, y, z);

  if (!Number.isFinite(length) || length < MIN_QUATERNION_LENGTH) {
    destination[offset] = 1;
    destination[offset + 1] = 0;
    destination[offset + 2] = 0;
    destination[offset + 3] = 0;
    return;
  }

  const inverseLength = 1 / length;

  destination[offset] = w * inverseLength;

  destination[offset + 1] = x * inverseLength;

  destination[offset + 2] = y * inverseLength;

  destination[offset + 3] = z * inverseLength;
}
